/*
 * File: any-helper.ts
 * File Created: 2023-12-25 03:22:48
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-06 08:36:37
 * Modified By: Val Liu
 * -----
 */

import lodash from "lodash";

export class AnyHelper {
    /**
     * Converts any type of value into a boolean.
     * * String "true" is explicitly considered true.
     * * String "false" is explicitly considered false.
     * @param from The value to be converted to boolean.
     * @returns The boolean representation of the input value.
     */
    static toBoolean(from: any): boolean | null {
        if (typeof from === "boolean") {
            /// if boolean, directly return.
            return from;
        } else if (typeof from === "string") {
            /// if string, match string "true" or "false"
            from = from.toLowerCase();
            if (from === "true") {
                return true;
            } else if (from === "false") {
                return false;
            } else {
                return null;
            }
        }
        return null;
    }

    /// it convert any type into string
    static toString(from: any): string {
        /// for primitive types (number / boolean / null / undefined / symbol),
        /// it converts them to their string representation.
        /// for object (array, functions, and custom objects), it calls the `toString()`
        /// method of the object.
        return String(from);
    }

    /// primitive
    static isPrimitive(item: any): boolean {
        return (
            (typeof item !== "object" && typeof item !== "function") ||
            item instanceof Date ||
            (typeof File !== "undefined" && item instanceof File) ||
            (typeof Blob !== "undefined" && item instanceof Blob)
        );
    }

    /// equal between source and target
    static equals(source: any, target: any): boolean {
        return lodash.isEqual(source, target);
    }
}
